import React from 'react';
import { PropTypes } from 'prop-types';

import headerImage from './header.png';

const Header = ({ className, t }) => (
  <div className={className}>
    <img src={headerImage} alt="header" />
    <p className="title">{t('header.title')}</p>
    <p className="subtitle">{t('header.subtitle')}:</p>
    <hr />
  </div>
);

Header.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

Header.defaultProps = {
  className: '',
  t: (t) => t,
};

export default Header;
